.uni-adjust--sidebar-start {
  margin-left: 48px !important;
}

.uni-adjust--aside-start {
  margin-left: 256px !important;
}

.uni-adjust--aside-sidebar-start {
  margin-left: 304px !important;
}

.uni-adjust--sidebar-end {
  margin-right: 48px !important;
}

.uni-adjust--aside-end {
  margin-right: 256px !important;
}

.uni-adjust--aside-sidebar-end {
  margin-right: 304px !important;
}
